export default "__VITE_ASSET__CF2quU4H__"